import type { CatColors, Category, CategoryGroup } from "./types";

const NEUTRAL: CatColors = {
  accent: "oklch(0.55 0.025 255)",
  tint: "oklch(0.966 0.004 255)",
  text: "oklch(0.44 0.02 255)",
  onAccent: "#fff",
  lit: "oklch(0.85 0.012 255)",
  glow: "oklch(0.62 0.025 255)",
};

/** Select the OKLCH palette for a Category. Missing or null hue gives the neutral palette. */
export function catColors(catDef: Category | null | undefined): CatColors {
  if (!catDef || catDef.hue == null) return NEUTRAL;
  const h = catDef.hue;
  return {
    accent: `oklch(0.62 0.14 ${h})`,
    tint: `oklch(0.967 0.024 ${h})`,
    text: `oklch(0.47 0.13 ${h})`,
    onAccent: "#fff",
    lit: `oklch(0.84 0.115 ${h})`,
    glow: `oklch(0.68 0.17 ${h})`,
  };
}

/** One singleton group per Category, in registry order: the grouping for games without explicit groups. */
export function defaultCategoryGroups(categories: Record<string, Category>): CategoryGroup[] {
  return Object.entries(categories).map(([id, c]) => ({ id, label: c.label, members: [id] }));
}
